import { PHONE, locationSchema } from "../structured-data-core";

export function getCharlotteStructuredData() {
  const url = "https://restorehair.com/locations/restore-charlotte/";
  const description =
    "Restore your confidence with the top hair restoration team serving Charlotte and the surrounding North Carolina metro. Over 20,000 procedures.";
  return [
    locationSchema("Charlotte", "7725 Ballantyne Commons Parkway, Suite 101", "Charlotte", "NC", PHONE, url, description),
    locationSchema("Cornelius", "19109 West Catawba Ave, Suite 200", "Cornelius", "NC", PHONE, url, description),
    locationSchema("Raleigh", "4509 Creedmoor Rd, Suite 201", "Raleigh", "NC", PHONE, url, description),
  ];
}
